<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				回访列表
			</div>
			<div class="boxNameR">
				<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
			</div>
		</div>
		<div class="msg" style="">
			<div class="msgItem">
				<div class="msgLabel">编号：</div>
				<div class="msgValue" v-if="from=='order'">
					{{detail.no}}
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">顾客：</div>
				<div class="msgValue">
					<a style="color:rgb(64, 158, 255);cursor: pointer;" @click="$router.push({path:'/huiyuan/huiyuanSee?id='+detail.user_info.user_id})">{{detail.user_info.nick_name}}</a>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">宠物：</div>
				<div class="msgValue" v-if="detail.user_info.user_id!==sankeId">
					<span v-if="from=='order'">{{detail.order_item_list.length>0?detail.order_item_list[0].pets_info.pets_name:''}}</span>
					<span v-if="from=='reservation'">{{detail.pet_info.nick_name}}</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">订单类型：</div>
				<div class="msgValue">
					<span v-if="from=='order'">消费</span>
					<span v-if="from=='reservation'">预约</span>
				</div>
			</div>
		</div>
		<div class="pageConBox" v-if="detail._id">
			<div style="padding:9px 16px;text-align: right;">
				<el-button type="warning" size="small" @click="dialog_state=true">新建</el-button>
			</div>
			<el-table :data="huifangList" max-height='800'>
				<el-table-column label="回访结果" width="250">
					<template slot-scope="scope">
						{{
							scope.row.visitResult.name
						}}
					</template>
				</el-table-column>
				<el-table-column label="回访内容" >
					<template slot-scope="scope">
						{{
							scope.row.visitContent
						}}
					</template>
				</el-table-column>
				<el-table-column label="回访时间" width="220">
					<template slot-scope="scope">
						{{
							$public.FTime(scope.row.visitTime)
						}}
					</template>
				</el-table-column>
				<el-table-column prop="customer_name" label="回访人" width="250">
					<template slot-scope="scope">
						{{
							scope.row.visitUser.userName
						}}
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog title="添加回访" :visible.sync="dialog_state" width="1000px">
			<el-form >
				<el-row>
					<el-col :span="18" :offset="2">
						<el-form-item label="回访结果：" :label-width="formLabelWidth">
							<el-select style="width:380px;" size="mini" class="select" v-model="visitResultId" placeholder="请选择回访结果">
								<el-option v-for="item in resultList" :key="item.item_id"
								:label="item.item_name" :value="item.item_id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row>
					<el-col :span="18" :offset="2">
						<el-form-item label="客户评分：" :label-width="formLabelWidth" >
							<el-select class="select" filterable v-model="form.title" placeholder="请选择" >
								<el-option v-for="item in 100"
								:key="item"
								:label="item"
								:value="item">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="18" :offset="2">
						<el-form-item label="回访内容：" :label-width="formLabelWidth" >
							<el-input type="textarea" rows="4" v-model="visitContent" autocomplete="off" placeholder="请输入回访内容"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialog_state = false" size="small">取 消</el-button>
				<el-button type="warning" @click="dialog_submit" size="small">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				sankeId:process.env.VUE_APP_sanke,
				detail:{
					user_info:{},
					order_item_list:[],
					pet_info:{},
					pay_info:{},
				},
				dialog_state:false,
				formLabelWidth: '120px',
				from:'',
				
				// 宋 回访
				visitResultId:'',
				resultList:[],
				visitContent:'',
				huifangList:[],
			}
		},
		beforeRouteEnter(to,from,next){
			next(vm=>{
				vm.getDetail()
			})
		},
		mounted(){
			this.from = this.$route.query.from;
			this.getDetail();
			this.$http.get(process.env.VUE_APP_zichan+'/api/SystemConfig/GetSystemDictionByCode', {code:'visitresult'}).then(res=>{
				if(res.code===0){
					this.resultList = res.data.item_list;
				}
			})
		},
		methods: {
			// 添加回访
			dialog_submit(){
				if(this.visitResultId==''){
					this.$message({
						message: '请选择回访结果',
						type: 'error'
					});
					return ;
				}
				if(this.visitContent==''){
					this.$message({
						message: '请输入回访内容',
						type: 'error'
					});
					return ;
				}
				let params = {
					"visitResult": {
						"id": this.visitResultId,
						"name": this.$public.getMatchingItem(this.resultList,'item_id',this.visitResultId).item_name,
					},
					"visitContent": this.visitContent,
					"returnVisitType": 4,
					"otherParam": this.detail.no,
					"memberInfo": {
						"memberId": this.detail.user_info.user_id,
						"memberName":  this.detail.user_info.nick_name,
						"memberMobile": this.detail.user_info.user_mobile,
						"remark": "",
					},
					"openInvitation": false, // 是否邀约
					"addInvitationInfo": { // 邀约信息
						// "invitationStaffInfo": {
						// 	"userId": "string",
						// 	"userName": "string"
						// },
						// "invitationType": 0,
						// "invitationRemark": "string",
						// "synergyInfo": {
						// 	"synergyStaffInfo": {
						// 		"userId": "string",
						// 		"userName": "string"
						// 	}
						// },
						// "invitationTime": 0,
						// "invitationShop": {
						// 	"shopId": "string",
						// 	"shopName": "string"
						// },
						// "demandList": [
						// 	{
						// 		"categoryInfo": {
						// 			"categoryId": "string",
						// 			"categoryName": "string",
						// 			"categoryCode": "string"
						// 		},
						// 		"color": "string",
						// 		"petSex": "string",
						// 		"ageInfo": {
						// 			"ageMin": 0,
						// 			"ageMax": 0,
						// 			"ageStr": "string"
						// 		},
						// 		"applyType": "string",
						// 		"vaccineNumber": 0,
						// 		"budgetMin": 0,
						// 		"budgetMax": 0,
						// 		"demandRemark": "string"
						// 	}
						// ]
					},
				}
				this.$http.post(process.env.VUE_APP_Url_8020+'/api/returnvisit/insert', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '添加成功',
							type: 'success'
						});
						this.visitResultId='';
						this.visitContent='';
						this.dialog_state = false;
						this.getHuifangList();
					}
				})
				// if(this.from == "order"){
				// 	let params = {
				// 		order_id: this.$route.query.id,
				// 		"visit_title": this.form.title,
				// 		"visit_result": this.form.result,
				// 		"visit_content": this.form.content
				// 	}
				// 	this.$http.post('/api/Order/AddVisit', params).then(res => {
				// 		if (res.code == 0) {
				// 			this.$message({
				// 				message: '添加成功',
				// 				type: 'success'
				// 			});
				// 		}
				// 		this.form.title='';
				// 		this.form.result='';
				// 		this.form.content='';
				// 		this.dialog_state = false;
				// 		this.getDetail();
				// 	})
				// }else if(this.from == 'reservation'){
				// 	let params = {
				// 		id: this.$route.query.id,
				// 		visit:{
				// 			"visit_title": this.form.title,
				// 			"visit_result": this.form.result,
				// 			"visit_content": this.form.content
				// 		}
				// 	}
				// 	this.$http.post('/api/Reservation/AddVisit', params).then(res => {
				// 		if (res.code == 0) {
				// 			this.$message({
				// 				message: '添加成功',
				// 				type: 'success'
				// 			});
				// 		}
				// 		this.form.title='';
				// 		this.form.result='';
				// 		this.form.content='';
				// 		this.dialog_state = false;
				// 		this.getDetail();
				// 	})
				// }
			},
			// 获取详情
			getDetail(){
				if(this.from === "order"){
					let params = {
						orderid: this.$route.query.id
					}
					this.$http.get('/api/Order/GetOrder', params).then(res => {
						if (res.code == 0) {
							this.detail = res.data;
							this.getHuifangList();
						}
					})
				}
				// else if(this.from === "reservation"){
				// 	let params = {
				// 		id: this.$route.query.id
				// 	}
				// 	this.$http.get('/api/Reservation/Detail', params).then(res => {
				// 		if (res.code == 0) {
				// 			this.detail = res.data;
				// 			// this.detail.visit_list = res.data.visits_list;
				// 		}
				// 	})
				// }
			},
			getHuifangList(){
				let params = {
					"keyword": "",
					"visitStatus": "",
					"memberId": this.detail.user_info.user_id,
					"visitUserId": "",
					"beginTime": 0,
					"endTime": 0,
					"returnVisitType": 4,
					"otherParam":  this.detail.no,
				}
				this.$http.post(process.env.VUE_APP_Url_8020+'/api/returnvisit/list', params).then(res => {
					if (res.code == 0) {
						this.huifangList = res.data.data||[];
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
.page{
	.msg {
		display: flex;
		flex-wrap: wrap;
		background-color: #fff;
		border-radius: 4px;
		.msgItem {
			width: 270px;
			font-size: 16px;
			color: $fontColor;
			display: flex;
			line-height: 40px;
			padding:0 20px;
			border-bottom:1px solid #F2F2F2;
			font-size: 12px;;
			.msgLabel {
				width: 80px;
				text-align: right;
				color: $fontColor;
			}
	
			.msgValue {}
		}
	}
	.pageConBox{
		margin-top:12px;
		padding:0 0;
		min-height: 600px;
	}
}
</style>
